import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Menu } from "lucide-react";

const PROVIDER_LABEL = { aws: "AWS", azure: "AZURE", gcp: "GCP", oracle: "ORACLE" };
const STATUS_DOT = { healthy: "live-dot", degraded: "live-dot amber", down: "live-dot red" };

export default function Header({ title, subtitle, onMenuClick }) {
  const [conn, setConn] = useState([]);
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get("/connectors");
        setConn(data || []);
      } catch (err) {
        console.error("header connectors load failed", err);
      }
    };
    load();
    const i = setInterval(load, 15000);
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => { clearInterval(i); clearInterval(t); };
  }, []);

  return (
    <header className="sticky top-0 z-20 backdrop-blur-md bg-zinc-950/85 border-b border-zinc-800">
      <div className="px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <button
            data-testid="header-menu-btn"
            onClick={onMenuClick}
            className="lg:hidden p-1.5 -ml-1 rounded-sm border border-zinc-800 bg-zinc-900 hover:bg-zinc-800 text-zinc-300"
            aria-label="Open menu"
          >
            <Menu className="w-5 h-5" />
          </button>
          <div className="min-w-0">
            <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-zinc-500 whitespace-normal break-words" data-testid="header-section-label">// {subtitle || "section"}</div>
            <h1 className="font-display text-xl sm:text-2xl font-bold tracking-tight whitespace-normal break-words" data-testid="header-title">{title}</h1>
          </div>
        </div>
        <div className="hidden md:flex items-center gap-2 flex-wrap justify-end" data-testid="connectors-strip">
          {conn.map((c) => (
            <div
              key={c.provider}
              data-testid={`connector-${c.provider}`}
              className="flex items-center gap-2 px-2.5 py-1.5 border border-zinc-800 rounded-sm bg-zinc-900/60"
            >
              <span className={STATUS_DOT[c.status] || "live-dot amber"} aria-hidden />
              <span className="text-[10px] font-mono uppercase tracking-widest text-zinc-300">{PROVIDER_LABEL[c.provider] || c.provider}</span>
              <span className="text-[10px] font-mono text-zinc-500">{c.latency_ms}ms</span>
            </div>
          ))}
          <div className="hidden xl:flex items-center gap-2 px-2.5 py-1.5 border border-cyan-500/30 rounded-sm bg-cyan-500/5">
            <span className="live-dot" />
            <span className="text-[10px] font-mono uppercase tracking-widest text-cyan-300" data-testid="header-clock">
              {time.toISOString().slice(11, 19)} UTC
            </span>
          </div>
        </div>
        {/* Compact connector strip for sm-md */}
        <div className="md:hidden flex items-center gap-1.5" data-testid="connectors-compact">
          {conn.map((c) => (
            <span
              key={c.provider}
              title={`${(PROVIDER_LABEL[c.provider] || c.provider)} ${c.status}`}
              className={STATUS_DOT[c.status] || "live-dot amber"}
              data-testid={`connector-dot-${c.provider}`}
            />
          ))}
        </div>
      </div>
    </header>
  );
}
